import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import React, { useEffect } from 'react';
import { checkStyles } from '@reach/utils';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var id = "reach-skip-nav"; ////////////////////////////////////////////////////////////////////////////////

/**
 * SkipNavLink
 *
 * Renders a link that remains hidden until focused to skip to the main content.
 *
 * @see Docs https://reacttraining.com/reach-ui/skip-nav#skipnavlink
 */

var SkipNavLink = function SkipNavLink(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? "Skip to content" : _ref$children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  useEffect(function () {
    return checkStyles("skip-nav");
  }, []);
  return React.createElement("a", Object.assign({}, props, {
    href: "#" + id,
    "data-reach-skip-link": true
  }), children);
};

if (process.env.NODE_ENV !== "production") {
  SkipNavLink.displayName = "SkipNavLink";
} ////////////////////////////////////////////////////////////////////////////////

/**
 * SkipNavContent
 *
 * Renders a div as the target for the link.
 *
 * @see Docs https://reacttraining.com/reach-ui/skip-nav#skipnavcontent
 */


var SkipNavContent = function SkipNavContent(props) {
  return React.createElement("div", Object.assign({}, props, {
    id: id
  }));
};

if (process.env.NODE_ENV !== "production") {
  SkipNavContent.displayName = "SkipNavContent";
}

export { SkipNavContent, SkipNavLink };